// import React from "react";
// import {
//   CheckOutlined,
//   ExclamationCircleOutlined,
//   CloseCircleOutlined,
// } from "@ant-design/icons";

// const PopupCard = ({ type, title, message, onConfirm, onCancel }) => {
//   const typeStyles = {
//     success: {
//       headerBg: "bg-[#06513D]",
//       icon: <CheckOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
//       iconBg: "bg-[#06513D]",
//       textColor: "text-[#06513D]",
//     },
//     warning: {
//       headerBg: "bg-[#FFC107]",
//       icon: <ExclamationCircleOutlined style={{ fontSize: 32 }} />,
//       iconBg: "bg-[#FFC107]",
//       textColor: "text-[#06513D]",
//     },
//     error: {
//       headerBg: "bg-[#D32F2F]",
//       icon: <CloseCircleOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
//       iconBg: "bg-[#D32F2F]",
//       textColor: "text-[#06513D]",
//     },
//   };

//   const { headerBg, icon, iconBg, textColor } =
//     typeStyles[type] || typeStyles.error;

//   return (
//     <div className="w-full sm:w-[320px] rounded-md shadow-md overflow-hidden bg-white text-center font-sans">
//       <div className={`py-2 ${headerBg} text-white font-semibold`}>{title}</div>
//       <div className=" p-6 flex flex-col items-center gap-3">
//         <div
//           className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBg}`}
//         >
//           {icon}
//         </div>
//         <p className={`text-base font-semibold  ${textColor}`}>{message}</p>
//         {(onConfirm || onCancel) && (
//           <div className="flex gap-4 ">
//             {onCancel && (
//               <button
//                 onClick={onCancel}
//                 className="px-4 py-2 rounded border border-[#06513D] text-[#06513D]"
//               >
//                 Cancel
//               </button>
//             )}
//             {onConfirm && (
//               <button
//                 onClick={onConfirm}
//                 className="px-4 py-2 rounded bg-[#06513D] text-white "
//               >
//                 Delete
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PopupCard;
import React from "react";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const PopupCard = ({
  type,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  widthClass = "sm:w-[320px]",
  confirmDisabled = false,
  cancelDisabled = false,
}) => {
  const typeStyles = {
    success: {
      headerBg: "bg-[#06513D]",
      icon: <CheckOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#06513D]",
      textColor: "text-[#06513D]",
    },
    warning: {
      headerBg: "bg-[#FFC107]",
      icon: <ExclamationCircleOutlined style={{ fontSize: 32 }} />,
      iconBg: "bg-[#FFC107]",
      textColor: "text-[#06513D]",
    },
    error: {
      headerBg: "bg-[#D32F2F]",
      icon: <CloseCircleOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#D32F2F]",
      textColor: "text-[#06513D]",
    },
  };

  const { headerBg, icon, iconBg, textColor } =
    typeStyles[type] || typeStyles.error;

  return (
    <div
      className={`w-full ${widthClass} rounded-md shadow-md overflow-hidden bg-white text-center font-sans`}
    >
      <div className={`py-2 ${headerBg} text-white font-semibold`}>{title}</div>
      <div className=" p-6 flex flex-col items-center gap-3">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBg}`}
        >
          {icon}
        </div>
        <p
          className={`text-base font-semibold  ${textColor}`}
          style={{ whiteSpace: "pre-line" }}
        >
          {message}
        </p>
        {(onConfirm || onCancel) && (
          <div className="flex gap-4 ">
            {onCancel && (
              <button
                onClick={onCancel}
                disabled={cancelDisabled}
                className={`min-w-[120px] px-4 py-2 rounded border bg-[#E6EDEB] border-[#06513D] text-[#06513D] font-medium transition-colors hover:!bg-[#F8F8F8] ${cancelDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {cancelText}
              </button>
            )}
            {onConfirm && (
              <button
                onClick={onConfirm}
                disabled={confirmDisabled}
                className={`min-w-[120px] px-4 py-2 rounded bg-[#06513D] text-white font-medium transition-colors hover:bg-[#387464] ${confirmDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupCard;
